export const CONTINUE = "Continue";
export const PICK_UP = "Pick-up";
export const DROP_OFF = "Drop-off";
